// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCenteringDown_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 22.998C27.3137 22.998 30 20.3118 30 16.998C30 16.6573 29.9716 16.3233 29.917 15.998H31.9381C31.979 16.3256 32 16.6594 32 16.998C32 21.4163 28.4183 24.998 24 24.998C19.5817 24.998 16 21.4163 16 16.998C16 16.6594 16.021 16.3256 16.0619 15.998H18.083C18.0284 16.3233 18 16.6573 18 16.998C18 20.3118 20.6863 22.998 24 22.998Z" class="svg-bg"/>
  <path d="M21.1707 15.998C21.0602 16.3108 21 16.6474 21 16.998C21 18.6549 22.3431 19.998 24 19.998C25.6569 19.998 27 18.6549 27 16.998C27 16.6474 26.9398 16.3108 26.8293 15.998H21.1707Z" class="svg-bg"/>
  <path d="M33 14.998H7V34.998H41V19H43V36.998H5V12.998H43V13H33V14.998Z" class="svg-bg"/>
  <path d="M35 11L40 17L45 11L41 11L41 2L39 2L39 11H35Z" fill="#EF8354"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 25H44V23H8V53H56V31H54V51H10V25Z" class="svg-bg"/>
  <path d="M41 29C41 33.9706 36.9706 38 32 38C27.0294 38 23 33.9706 23 29C23 28.3126 23.0771 27.6432 23.223 27H21.1814C21.0622 27.6486 21 28.317 21 29C21 35.0751 25.9249 40 32 40C38.0751 40 43 35.0751 43 29C43 28.317 42.9378 27.6486 42.8186 27H40.777C40.9229 27.6432 41 28.3126 41 29Z" class="svg-bg"/>
  <path d="M28 29C28 28.2714 28.1948 27.5883 28.5351 27H35.4649C35.8052 27.5883 36 28.2714 36 29C36 31.2091 34.2091 33 32 33C29.7909 33 28 31.2091 28 29Z" class="svg-bg"/>
  <path d="M46.5 19.9999L52.5 27.9999L58.5 19.9999H54L54 8L51 8L51 19.9999H46.5Z" fill="#EF8354"/>
</svg>
`;
/**
 * IconMedCenteringDown is a generated icon component.
 */
let IconMedCenteringDown = IconMedCenteringDown_1 = class IconMedCenteringDown extends IconBaseElement {
    render() {
        return html `${IconMedCenteringDown_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCenteringDown.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedCenteringDown = IconMedCenteringDown_1 = __decorate([
    customElement('zui-icon-med-centering-down')
], IconMedCenteringDown);
export { IconMedCenteringDown };
